export enum SearchResourceType {
    SITEMAP = 'SITEMAP',
    RULE_TYPES = 'RULE_TYPES'
}
